import { useState } from 'react';
import { UMButton, UMIcon } from '../../urbanmap/_components';
import { PLAN } from '../proposition-c/tokens';
import { Modal } from '../proposition-c/ui';
import { paramsComplete, useImpact } from './hooks';
import { StepHypotheses } from './StepHypotheses';
import type { AoParams, Bootstrap } from './types';

/** PRD US-002 — AO hypotheses stay modifiable after creation, without history. */
export function AoParamsDialog({
  data, params, onClose, onSave,
}: {
  data: Bootstrap;
  params: AoParams;
  onClose: () => void;
  onSave: (p: AoParams) => void;
}) {
  const [draft, setDraft] = useState<AoParams>(params);
  const impact = useImpact(data.geo, draft);
  const ok = paramsComplete(draft);

  return (
    <Modal
      title="Hypothèses de l’AO"
      onClose={onClose}
      width={720}
      footer={
        <>
          <UMButton variant="secondary" onClick={onClose}>Annuler</UMButton>
          <UMButton icon="check" disabled={!ok} onClick={() => onSave(draft)}>Appliquer</UMButton>
        </>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ display: 'flex', gap: 10, padding: 10, background: PLAN.warningBg, border: `1px solid ${PLAN.warningBorder}`, color: PLAN.warningText, fontSize: 13 }}>
          <UMIcon name="info" size={18} color={PLAN.warningText} />
          <div>
            Modifier les hypothèses recalcule immédiatement les consommations du projet. Aucun historique n’est
            conservé : seule la dernière version fait foi.
          </div>
        </div>
        <StepHypotheses
          value={draft}
          onChange={setDraft}
          stations={data.weatherStations}
          years={data.weatherYears}
          impact={impact}
          impactVariant="A"
          ready={ok}
        />
      </div>
    </Modal>
  );
}
